<template lang="pug">
v-container(fluid='' style='max-width: 1400px;' v-scroll='redraw_masonry')
  v-row
    v-col
      search-bar(:setsn='default_setsn')
  v-row
    v-card.mx-3
      v-card-title
        h2(style='display: inline; font-family: 微軟正黑體;') {{$t(&quot;pd0.t&quot;)}}
      v-card-text
        span {{$t(&quot;pd0.d&quot;)}}
        br
        span {{$t(&quot;pd0.d2&quot;)}}
  v-row
    v-col(v-for='mainset_id in prods' :key='`sets_layout_0_${mainset_id}`' cols='12' :md='12/3')
      v-card(min-height='340' :to='`/${mainset_id}`')
        v-toolbar(:height='64*3' :src='`/images/${mainset_id}/banner_bg.jpg`')
          template(v-slot:img='{ props }')
            v-img(v-bind='props' :eager='eager_image')
          v-img.mb-4(contain='' position='left' style='align-self: flex-end;' :eager='eager_image' :height='64' :src='`/images/${mainset_id}/logo.png`')
        v-card-text {{$t(&grave;pd.${mainset_id}.desc_short&grave;)}}
</template>
<script>
import {debug} from "@/api/logging"
import { mainsets, default_search_setsn } from "@/api"
import SearchBar from "@/components/SearchBar"
import {pd} from "@/locales/zh-TW.json"

export default {
  name: "VaultsHome",
  computed: {},
  methods: {
    bg_src(mainset_id) {
      // return `background: url("/images/${mainset_id}/banner_bg.jpg") no-repeat center center fixed; background-size: cover; height: 224px;`
      if(this.test_mode == 1) {
        return `background: url("/images/${mainset_id}/banner_bg.jpg") no-repeat center top; background-size: 100%; height: 200px;`
      }
      else {
        return `background: url("/images/${mainset_id}/banner_bg.jpg") no-repeat center center fixed; background-size: cover; height: 224px;`
      }
    },
    redraw_masonry(delay=200) {
      const that = this
      if(delay == 0) {
        this.$nextTick(()=>{
          that.$redrawVueMasonry()
        })
        return
      }
      if(that.$masonry_redraw) {
        clearTimeout(that.$masonry_redraw)
      }
      that.$masonry_redraw = setTimeout(()=>{
        that.$redrawVueMasonry()
        delete that.$masonry_redraw
      }, delay)
    }
  },
  updated() {
    this.redraw_masonry()
  },
  mounted() {
    this.$store.commit('set_mainset')
    this.$store.subscribe(mutation => {
      if(mutation.type == 'set_test_mode') {
        this.test_mode = mutation.payload
      }
    })
    this.redraw_masonry()
  },
  props: {
  },
  data() {
    const prods = []
    for(let k in pd) {
      if(mainsets.includes(k)) prods.push(k)
    }
    const test_mode = this.$store.state.test_mode
    return {
      prods,
      default_setsn: default_search_setsn,
      dark_banner: ['art', 'waa'],
      test_mode,
      eager_image: undefined,
    };
  },
  components: {
    SearchBar,
    },
}
</script>
